// extracted by mini-css-extract-plugin
module.exports = {"background":"style_background__3Mc3C","component":"style_component__3fddK","title":"style_title__2pea_"};